/* unplugin-vue-components disabled */import script from "./AddComment.vue?vue&type=script&setup=true&name=AddComment&lang=js"
export * from "./AddComment.vue?vue&type=script&setup=true&name=AddComment&lang=js"

import "./AddComment.vue?vue&type=style&index=0&id=05f676df&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f676df"]])

export default __exports__